/**
 * Default sub-distributor ID used for HQ/admin/distributor roles.
 * This represents the "global" scope for products visible to all stores.
 */
export const HQ_SUB_DISTRIBUTOR_ID = 196;

/**
 * SPAR distributor i_customer. When this distributor opens "Topup - Promo Data",
 * the product list is loaded from the same source as "Topup - Brand Promo Data"
 * so Central Office and Retailer see the same products (SPAR-specific).
 */
export const SPAR_DISTRIBUTOR_I_CUSTOMER = 26215;
